import React from "react";

function Client() {
  const skills = [
    {
      id: 1,
      icon: "bx-badge-check",
      name: "HTML",
      level: "Advanced",
    },
    {
      id: 2,
      icon: "bx-badge-check",
      name: "CSS",
      level: "Advanced",
    },
    {
      id: 3,
      icon: "bx-badge-check",
      name: "Javascript",
      level: "Advanced",
    },
    {
      id: 4,
      icon: "bx-badge-check",
      name: "Tailwind",
      level: "Advanced",
    },
    {
      id: 5,
      icon: "bx-badge-check",
      name: "DSA",
      level: "Advanced",
    },
    {
      id: 6,
      icon: "bx-badge-check",
      name: "MERN Stack",
      level: "Advanced",
    },
    {
      id: 7,
      icon: "bx-badge-check",
      name: "Git",
      level: "Advanced",
    },
    {
      id: 8,
      icon: "bx-badge-check",
      name: "GitHub",
      level: "Advanced",
    }
  ];
  return (
    <div className="skills__content">
      <h3 className="skills__title">Technical Skills</h3>

      <div className="skills__box">
        <div className="skills__group">
          {skills.map((data) => (
            <div key={data.id} className="skills__data">
              <i className={`bx ${data.icon}`}></i>
              <div>
                <h3 className="skills__name">{data.name}</h3>
                <span className="skills__level">{data.level}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Client;
